import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MenuNavigationService } from 'app/services/menu-navigation.service';
import { SectionButtonsComponent } from '../section-buttons/section-buttons.component';
import { AnalyticsService } from 'app/services/analytics.service';
import { APP_CONSTANTS } from 'app/app.constants';
import { ReferenceComponent } from '../reference/reference.component';

@Component({
  selector: 'app-mega-menu',
  templateUrl: './mega-menu.component.html',
  styleUrls: ['./mega-menu.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, SectionButtonsComponent, ReferenceComponent]
})
export class MegaMenuComponent {
  protected selectedSection = '';
  protected selectedSectionIndex = -1;
  protected selectedSubSectionIndex = -1;
  protected isReferences = false;
  protected productList = [];
  protected subSections = [];
  @Input() protected selectedProduct = '';
  @Input() protected selectedProductIndex = -1;
  @Output() protected closeMegamenu = new EventEmitter<string>();

  constructor(
    protected menuNavigationService: MenuNavigationService,
    protected analytics: AnalyticsService
  ) {
    this.productList = menuNavigationService.productsOverview;
  }

  public ngOnChanges(changes) {
    if(this.selectedProductIndex === this.menuNavigationService.selectedProductIndex) {
      this.showSubSections(this.menuNavigationService.selectedSectionIndex, this.productList[this.selectedProductIndex].sections[this.menuNavigationService.selectedSectionIndex], 'auto');
      this.selectedSubSectionIndex = this.menuNavigationService.selectedSubSectionIndex;
    } else {
      this.selectedSectionIndex = -1;
      this.selectedSubSectionIndex = -1;
      this.subSections = [];
    }
  }

  public showSubSections(index, section, operation?) {
    if(this.selectedSectionIndex !== index) {
      this.selectedSectionIndex = index;
      this.subSections = section?.sections;
      this.selectedSection = section?.title;
      if(operation === 'manual') {
        this.selectedSubSectionIndex = -1;

        if(section.sections.length === 0 || (section.sections.length === 1 && section.sections[0].title === '')) {
          this.menuNavigationService.title = this.selectedProduct;
          this.menuNavigationService.subTitle = this.selectedSection;
          this.menuNavigationService.selectedProductIndex = this.selectedProductIndex;
          this.menuNavigationService.selectedSectionIndex = this.selectedSectionIndex;
          this.menuNavigationService.updateProductList({
            selectedProductIndex: this.menuNavigationService.selectedProductIndex,
            selectedSectionIndex: this.menuNavigationService.selectedSectionIndex
          });
          this.menuNavigationService.selectedSubSectionIndex = -1;
          this.analytics.trackAction(this.productList[this.selectedProductIndex].productName, this.productList[this.selectedProductIndex].sections[this.selectedSectionIndex].title);
          this.analytics.trackState(`${this.productList[this.selectedProductIndex].productName} > ${this.productList[this.selectedProductIndex].sections[this.selectedSectionIndex].title}`);
          this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT);
          this.scrollToSection(this.productList[this.selectedProductIndex].sections[this.selectedSectionIndex].id);
          this.menuNavigationService.checkClinicalStudies();
          this.close();
        }
      }
    }
  }

  public selectSubSection(index) {
    if(this.selectedSubSectionIndex !== index) {
      this.selectedSubSectionIndex = index;
    }
    this.menuNavigationService.title = this.selectedProduct;
    this.menuNavigationService.subTitle = this.selectedSection;
    this.menuNavigationService.selectedProductIndex = this.selectedProductIndex;
    this.menuNavigationService.selectedSectionIndex = this.selectedSectionIndex;
    this.menuNavigationService.updateProductList({
      selectedProductIndex: this.menuNavigationService.selectedProductIndex,
      selectedSectionIndex: this.menuNavigationService.selectedSectionIndex
    });
    this.menuNavigationService.selectedSubSectionIndex = this.selectedSubSectionIndex;
    this.menuNavigationService.checkClinicalStudies();
    this.analytics.trackAction(this.productList[this.selectedProductIndex].sections[this.selectedSectionIndex].title, this.productList[this.selectedProductIndex].productName);
    this.menuNavigationService.navigateByUrl(APP_CONSTANTS.ROUTE_PATHS.PRODUCT_CONTENT);
    this.scrollToSection(this.productList[this.selectedProductIndex].sections[this.selectedSectionIndex].sections[this.selectedSubSectionIndex].id);
    this.close();
  }

  public close() {
    this.closeMegamenu.emit(`${this.selectedProductIndex}`); // Pass selectedProductIndex to header desktop to close the megamenu
    this.selectedSectionIndex = -1;
    this.selectedSubSectionIndex = -1;
  }

  protected scrollToSection(id) {
    setTimeout(() => {
      this.menuNavigationService.scrollToElement(id);
    },100);
  }

  protected showReferences(isOpen) {
    this.isReferences = isOpen;
  }
}
